import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { endpoints } from '../../endpoints';


@Injectable({ providedIn: 'root' })
export class NsideIdentityService {

  private apiToken: string | null = null;
  private tokenExpiry: number = 0;

  constructor(private http: HttpClient) {}

  // Ask Identity Gateway to verify cookie
  getUser() {
    const url = environment.identityUrl + endpoints.verifySession;
    return this.http
      .post<any>(url, {}, { withCredentials: true })
      .pipe(
        map(res => res.claims),
        catchError(() => of(null))
      );
  }

  isAuthenticated() {
    return this.getUser().pipe(
      map(user => !!user)
    );
  }

  // Hits an admin-only identity-v2 endpoint; 200 means the user is in the
  // NsideAdmin table, anything else (403/401) means they aren't.
  isNsideAdmin(): Observable<boolean> {
    const url = environment.identityUrl + endpoints.adminProbe;
    return this.http
      .get(url, {
        withCredentials: true,
        headers: { Accept: 'application/json' },
        observe: 'response'
      })
      .pipe(
        map(res => res.status === 200),
        catchError(() => of(false))
      );
  }

  // Get API token from identity-v2 (exchanges session cookie for Bearer JWT)
  fetchApiToken(): Observable<string | null> {
    const url = environment.identityUrl + endpoints.getApiToken;
    return this.http
      .post<any>(url, {}, { withCredentials: true })
      .pipe(
        map(res => {
          if (res.success && res.api_token) {
            this.apiToken = res.api_token;
            // Set expiry with 60s buffer before actual expiry
            this.tokenExpiry = Date.now() + ((res.expires_in - 60) * 1000);
            return this.apiToken;
          }
          return null;
        }),
        catchError(() => of(null))
      );
  }

  getToken(): string | null {
    if (this.apiToken && Date.now() < this.tokenExpiry) {
      return this.apiToken;
    }
    return null;
  }

  isTokenValid(): boolean {
    return !!this.getToken();
  }

  clearToken() {
    this.apiToken = null;
    this.tokenExpiry = 0;
  }

  logout() {
    this.clearToken();
    window.location.href = environment.identityUrl + endpoints.logout;
  }
}
